import { z } from 'zod'

export const LocationTypeEnum = {
  RATING_AREA: 5,
  ZIP: 10,
  ANY_ZIP: 15,
  COUNTY: 20,
  ANY_COUNTY: 25,
  STATE: 30,
  ANY_STATE: 35,
  STATE_RA_COUNTY_ZIP: 2000,
  STATE_COUNTY_ZIP: 3000,
  STATE_RA_ZIP: 4000,
  STATE_RA_COUNTY: 5000,
  STATE_ZIP: 6000,
  STATE_RATING_AREA: 7000,
  STATE_COUNTY: 8000,
  STATE_WIDE: 9000,
  NATION_WIDE: 10000,
} as const
export const LocationTypeSchema = z.nativeEnum(LocationTypeEnum)
export type LocationType = z.infer<typeof LocationTypeSchema>

const LOCATION_TYPE_VALUES = Object.values(LocationTypeEnum) as LocationType[]

export function parseLocationType(value: number): LocationType | null {
  if (LOCATION_TYPE_VALUES.includes(value as LocationType)) {
    return value as LocationType
  }

  return null
}
